import { IconSet } from '../interface/icon.interface';

/** Namespace holding the order side menu icons */
export const SIDE_MENU_ICON_NAMESPACE = 'sidemenu';

export class IconConfig {
  /** Icon sets registered on app start, available to every component as <mat-icon svgIcon="namespace:name"> */
  static readonly iconSets: ReadonlyArray<IconSet> = [
    {
      namespace: SIDE_MENU_ICON_NAMESPACE,
      path: 'assets/icon/sidemenu',
      icons: [
        'bldg',
        'certification',
        'comments',
        'comp-map',
        'comps',
        'cost-approach',
        'details',
        'docs-and-comments',
        'flood',
        'grid',
        'income',
        'inventory',
        'land',
        'locality',
        'long-term-rent',
        'neighborhood',
        'order-summary',
        'photos',
        'plat',
        'preview',
        'prior-sales',
        'project',
        'project-information',
        'reconciliation',
        'sales-comparison',
        'short-term-rent',
        'sketch',
        'subject-property',
        'trends',
        'value',
      ],
    },
  ];
}
